/**
 * The single point the API client reads its bearer token from.
 *
 * `setAuthToken` is how the auth store publishes the token it holds. `readAuthToken`
 * is the seam: Story 4 replaces the default reader with one backed by Nuxt's
 * `useCookie('auth.currentUser')`, so the token becomes per-request without any
 * call site changing.
 *
 * `storedToken` is module state, and therefore shared by every concurrent request
 * once SSR is on. That is why the reader has to be replaced rather than kept.
 */
let storedToken = ''
let readToken = () => storedToken

export function setAuthToken(value) {
    storedToken = value || ''
}

export function setAuthTokenReader(reader) {
    readToken = reader
}

export function readAuthToken() {
    return readToken()
}
